import React, { FunctionComponent, useMemo, useRef } from "react"
import {Table, TableProps} from './Table'
import {TableStore, TableStoreContext} from './TableStore'
import { observer } from 'mobx-react'


export interface TableWithMetaHeaderProps extends TableProps {
  totalCount: number, // Total number of unfiltered available rows
  availableCount: number, // number of matching rows that may be paged to
  itemLabel: string
}


const TableWithStore: FunctionComponent<TableWithMetaHeaderProps> = observer((props) => {
  const instanceRef = useRef(null)
  const tableStore = useMemo(() => new TableStore(), [instanceRef])

  if (!props.data) {
    return null
  }
  
  tableStore.setData(props.data)

  return (
    <TableStoreContext.Provider value={tableStore}>
      <div className={`sch_table_container${props.isLoadingMore ? ' loading more' : ''}`}>
        <div className={`sch_meta_header`}>
          <div className={`sch_meta_header_counts`}>

            <div className="item_count">
              {props.isLoading ? "Loading" : (
                <>
                  <b>{(props.availableCount || 0).toLocaleString()}</b>
                  {props.availableCount !== props.totalCount && 
                    <>
                      &nbsp;of&nbsp;
                      <b>{(props.totalCount || 0).toLocaleString()}</b> Total
                    </>
                  } 
                </>
              )}
              &nbsp;{props.totalCount === 1 ? `${props.itemLabel}` : `${props.itemLabel}s`}
            </div>
            {/* <div className={``}>
              (filter applied)
              sorted by
              &nbsp;<b>Updated At</b>
            </div> */}
          </div>
          <div className={`sch_meta_header_config`}>
          </div>
        </div>
        <TableStoreContext.Consumer>
          {tableStore => (
            <Table
              data={props.data}
              isLoading={props.isLoading}
              isLoadingMore={props.isLoadingMore}
              onRequestNextPage={props.onRequestNextPage}
              isReadyForNextPage={props.isReadyForNextPage}
              totalCount={props.totalCount}
              sortField={props.sortField}
              sortDir={props.sortDir}
              onChangeSort={props.onChangeSort}
              tableStore={tableStore}
            />
          )}
        </TableStoreContext.Consumer>
      </div>
    </TableStoreContext.Provider>
  )
})

export default TableWithStore